(function () {
    "use strict";

    angular
        .module("app")
        .factory("TransferChecklistService", TransferChecklistService);

    function TransferChecklistService(WebApiService) {

        var service = {
            find: find,
            create: create,
            getTransferProductTypes: getTransferProductTypes,
            save: save,
            getPdf: getPdf,
            exportChecklist: exportChecklist,
            upload: upload,
            syncPatternLevelItemsPreview: syncPatternLevelItemsPreview
        };

        return service;

        function find(prototypeId, fromFactoryKey, toFactoryKey) {
            return WebApiService.get("/api/TransferChecklist/Find?prototypeId=" + prototypeId + "&fromFactoryKey=" + fromFactoryKey + "&toFactoryKey=" + toFactoryKey);
        }

        function create(prototypeId, fromFactoryKey, toFactoryKey) {
            return WebApiService.postJson("/api/TransferChecklist/Create?prototypeId=" + prototypeId + "&fromFactoryKey=" + fromFactoryKey + "&toFactoryKey=" + toFactoryKey);
        }

        function getTransferProductTypes() {
            return WebApiService.get("/api/TransferChecklist/GetTransferProductTypes");
        }

        function save(checklist) {
            return WebApiService.postJson("/api/TransferChecklist/Save", checklist, {}, false);
        }

        function getPdf(transferChecklistId) {
            return WebApiService.get("/api/TransferChecklist/GetPdf?transferChecklistId=" + transferChecklistId);
        }

        function exportChecklist(so) {
            return WebApiService.postJson("/api/TransferChecklist/Export", so, null, false);
        }

        function upload(file) {
            return WebApiService.postFile("/api/TransferChecklist/Upload", file);
        }

        function syncPatternLevelItemsPreview(intoThisChecklistId, isTariffMitigationTransfer) {
            return WebApiService.get("/api/TransferChecklist/SyncPatternLevelItemsPreview?intoThisChecklistId=" + intoThisChecklistId + "&isTariffMitigationTransfer=" + isTariffMitigationTransfer, null, null, false);
        }
    }
})();
